package ru.villawonka.app.presentation.design.components

import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.material.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import cafe.adriel.voyager.navigator.tab.LocalTabNavigator
import cafe.adriel.voyager.navigator.tab.Tab
import ru.villawonka.app.getLogger
import ru.villawonka.app.getTelegram
import ru.villawonka.app.presentation.design.theme.AppColors

@Composable
fun AppBottomNavigationBar(
    content: @Composable RowScope.() -> Unit
) {
    val bottomPadding = getTelegram()?.getSafeAreaInset()?.bottom ?: 0

    BottomNavigation(
        windowInsets = WindowInsets(bottom = bottomPadding),
        contentColor = MaterialTheme.colors.filledNavigationBarContentEnabled,
        backgroundColor = MaterialTheme.colors.filledNavigationBarBackgroundEnabled,
        content = content,
    )
}

@Composable
fun RowScope.AppBottomNavigationItem(tab: Tab) {
    val tabNavigator = LocalTabNavigator.current

    BottomNavigationItem(
        selected = tabNavigator.current == tab,
        onClick = { tabNavigator.current = tab },
        icon = { Icon(painter = tab.options.icon!!, contentDescription = tab.options.title) },
        selectedContentColor = MaterialTheme.colors.filledNavigationBarContentSelected,
        unselectedContentColor = MaterialTheme.colors.filledNavigationBarContentEnabled
    )
}

private val Colors.filledNavigationBarContentEnabled: Color
    @Composable
    get() = if (isLight) AppColors.grayLight500 else AppColors.grayDark400

private val Colors.filledNavigationBarBackgroundEnabled: Color
    @Composable
    get() = if (isLight) AppColors.grayLight50 else AppColors.grayDark900

private val Colors.filledNavigationBarContentSelected: Color
    @Composable
    get() = if (isLight) AppColors.violet700 else AppColors.violet700